import { IonSpinner, useIonToast } from '@ionic/react';
import classNames from 'classnames';
import { FullPost } from 'model';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../App';
import { useDeletePostImageMutation } from '../api/PostApi';
import { LoginState } from '../state/loginSlice';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
import { IconButton } from './IconButton';
import { IconTrash } from './QuirkIcons';

export const IconImageDelete: React.FC<{ post: FullPost; imageName: string; onDelete?: () => void }> = ({
	post,
	imageName,
	onDelete
}) => {
	const inputRef = useRef<HTMLInputElement>(null);
	const [triggerDeletePostImage, { error: deleteError, isLoading, isSuccess }] = useDeletePostImageMutation();
	const state: LoginState = useSelector<RootState, LoginState>(state => state.login);
	const [showToast] = useIonToast();

	if (deleteError) {
		showToast({ duration: 1500, color: 'danger', message: 'Error deleting image' });
	}
	const handleDelete = async () => {
		if (post) {
			await triggerDeletePostImage({ document: post as FullPost, imageName });
			if (onDelete) {
				onDelete();
			}
		}
	};

	const imageHandler = () => {
		if (inputRef.current) {
			inputRef.current.value = '';
		}
		handleDelete();
	};
	useEffect(() => {
		if (deleteError) {
			showToast({ duration: 1500, color: 'danger', position: 'top', message: 'Error deleting image' });
		} else if (isSuccess) {
			showToast({ duration: 1500, color: 'success', position: 'top', message: 'Image Deleted' });
		}
	}, [deleteError, isSuccess, showToast]);
	return (
		<>
			{post.author === state.user._id && (
				<>
					<div className={classNames(sharedStyles.controlIconContainer)}>
						{isLoading ? (
							<IonSpinner
								onClick={() => inputRef.current?.click()}
								className={classNames(sharedStyles.contrastColor, sharedStyles.controlIcon)}
							/>
						) : (
							<IconButton
								icon={
									<div className={sharedStyles.contrastColor}>
										<IconTrash />
									</div>
								}
								className={classNames(sharedStyles.contrastColor, sharedStyles.controlIcon)}
								onClick={imageHandler}
							/>
						)}
					</div>
				</>
			)}
		</>
	);
};
